import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-timeline-item',
  components: {},
})
export default class TimelineItem extends Vue {
  @Prop({ type: String, default: 'primary' }) readonly variant: string;
  @Prop(String) readonly dateTime: string;
  @Prop({ type: String, default: 'DD/MM/YYYY' }) readonly dateFormat: string;
  @Prop({ type: String, default: 'HH:mm:ss' }) readonly timeFormat: string;

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
